import { useLogger } from "@amzn/xb-hooks";
import { Helmet } from "react-helmet";
import { LiveInterceptor } from "../live-component";

export type MetaDataInterface = {
  metaData?: {
    title?: string;
    description?: string;
  };
};

/**
 *  Set the metatags used for SEO, this is supplied via vendPageComponentSource
 */
export const metaDataInterceptor: LiveInterceptor<MetaDataInterface> = (_, Response) => {
  const ResponseWithMetadata = (props: MetaDataInterface) => {
    const { debug } = useLogger();
    const { metaData: { title, description } = {} } = props;
    debug(`adding meta data ${JSON.stringify(props)}`);
    return (
      <>
        <Helmet>
          {title && <title>{title}</title>}
          {description && <meta name="description" content={description} />}
        </Helmet>
        <Response {...props} />
      </>
    );
  };
  return ResponseWithMetadata;
};
